import {
  Button,
  Container,
  FormControl,
  InputAdornment,
  InputLabel,
  MenuItem,
  Paper,
  Select,
  Stack,
  TextField,
} from "@mui/material";
import React from "react";
import { CreatePosition } from "../../../../domain/usecases/create-position";
import Navbar from "../../components/navbar";

type Props = {
  createPosition: CreatePosition;
};

export const NewPosition: React.FC<Props> = ({ createPosition }) => {
  const [classification, setClassification] = React.useState<string>("high");
  const [street, setStreet] = React.useState<number | null>(null);
  const [building, setBuilding] = React.useState<number | null>(null);
  const [level, setLevel] = React.useState<number | null>(null);
  const [apartment, setApartment] = React.useState<number | null>(null);
  const [weight, setWeight] = React.useState<number | null>(null);

  const handleClick = async () => {
    if (!street) return alert("Preencha a rua antes de continuar");
    if (!building) return alert("Preencha o prédio antes de continuar");
    if (!weight) return alert("Preencha o limite de peso antes de continuar");
    const warehouseString = localStorage.getItem("currentWarehouse");
    const warehouse = warehouseString
      ? (JSON.parse(warehouseString) as {
          id: number;
          name: string;
        } | null)
      : undefined;
    try {
      const res = await createPosition.create({
        street,
        building,
        level: level || 0,
        apartment: apartment || 0,
        classification,
        weightLimit: weight,
        warehouseId: warehouse!.id,
      });
      if (res) return alert("Posição criada com sucesso");
      setApartment(null);
      setBuilding(null);
      setStreet(null);
      setLevel(null);
      setWeight(null);
    } catch (error) {
      alert("Um erro inesperado aconteceu. Tente novamente.");
    }
  };

  return (
    <>
      <Navbar title="Nova Posição" />
      <Paper sx={{ my: "40px", mx: "40px" }}>
        <Stack spacing={4} sx={{ p: "20px" }}>
          <TextField
            label="Rua"
            size="small"
            sx={{ width: "50%" }}
            type="number"
            value={street}
            onChange={(e: any) => {
              setStreet(parseInt(e.target.value));
            }}
          />
          <TextField
            label="Prédio"
            size="small"
            sx={{ width: "50%" }}
            type="number"
            value={building}
            onChange={(e) => {
              setBuilding(parseInt(e.target.value));
            }}
          />
          <TextField
            label="Nível"
            size="small"
            sx={{ width: "50%" }}
            type="number"
            value={level}
            onChange={(e) => {
              setLevel(parseInt(e.target.value));
            }}
          />
          <TextField
            label="Apartamento"
            size="small"
            sx={{ width: "50%" }}
            type="number"
            value={apartment}
            onChange={(e) => {
              setApartment(parseInt(e.target.value));
            }}
          />

          <FormControl sx={{ width: "50%" }} size="small">
            <InputLabel id="demo-simple-select-label">
              Giro da Posição
            </InputLabel>
            <Select
              labelId="demo-simple-select-label"
              id="demo-simple-select"
              value={classification}
              label="Giro da Posição"
              onChange={(e) => {
                setClassification(e.target.value);
              }}
            >
              <MenuItem value={"high"}>Alto</MenuItem>
              <MenuItem value={"medium"}>Médio</MenuItem>
              <MenuItem value={"low"}>Baixo</MenuItem>
            </Select>
          </FormControl>

          <TextField
            label="Peso Suportado na Posição"
            size="small"
            sx={{ width: "50%" }}
            type="number"
            InputProps={{
              endAdornment: (
                <InputAdornment position="start">kg</InputAdornment>
              ),
            }}
            value={weight}
            onChange={(e) => {
              setWeight(parseFloat(e.target.value));
            }}
          />
          <Container sx={{ display: "flex", justifyContent: "flex-end" }}>
            <Button variant="contained" size="large" onClick={handleClick}>
              Criar
            </Button>
          </Container>
        </Stack>
      </Paper>
    </>
  );
};
